import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ComplaintExplorer } from '../components/ComplaintExplorer';
import { CtaBand } from '../components/CtaBand';
export function Complaints() {
  return <>
      <PageHeader title="Pijnklachten" crumbs={[{
      label: 'Pijnklachten'
    }]} intro="Kies een pijnklacht. Per klacht ziet u welke behandelingen wij bieden, met de bijbehorende patiëntenfolder." data-id="element-452" data-mp="1lfbb0xfsqzs" />
      <section className="mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-16" data-id="element-453" data-mp="3nru2wiazd846">
        <ComplaintExplorer data-id="element-454" data-mp="3iu2ehy9jo44q" />
      </section>
      <CtaBand data-id="element-455" data-mp="3et8pf1kd8ja9" />
    </>;
}